/* -------------------------------------------------------------------------- */
/* ---------------------------------- FRONT --------------------------------- */

// CSS
import "./scss/theme.scss";

// JS
import "./js/theme.js";